module.exports = __webpack_public_path__ + "assets/ef69d3dc32828f7155743c1b53609299.png";